import React, { useState } from "react";

export default function AuditPanel({ audits, language }) {
    const [filteredAudits, setFilteredAudits] = useState(audits);

    React.useEffect(() => {
        setFilteredAudits(audits);
    }, [audits]);

    return (
        <div className="space-y-6">
            <h2 className="text-2xl font-semibold text-gray-900">
                {language === "zh" ? "審計日誌" : "Audit Logs"}
            </h2>
            <div className="bg-white rounded-lg shadow">
                <div className="divide-y divide-gray-200 max-h-96 overflow-y-auto">
                    {filteredAudits.map((audit) => (
                        <div key={audit.id} className="p-6 hover:bg-gray-50">
                            <div className="flex items-start space-x-4">
                                <div className="flex-shrink-0">
                                    <div className="w-10 h-10 bg-gray-200 rounded-full flex items-center justify-center">
                                        <svg
                                            className="w-5 h-5 text-gray-600"
                                            fill="none"
                                            stroke="currentColor"
                                            viewBox="0 0 24 24"
                                        >
                                            <path
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                strokeWidth={2}
                                                d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                                            />
                                        </svg>
                                    </div>
                                </div>
                                <div className="flex-1 min-w-0">
                                    <div className="flex md:flex-row flex-col gap-2 md:items-center items-start justify-between mb-2">
                                        <div className="flex items-center space-x-2">
                                            <span className="text-sm font-medium text-gray-900">
                                                {audit.user || audit.actor}
                                            </span>
                                        </div>
                                        <span className="text-sm text-gray-500">
                                            {audit.timestamp}
                                        </span>
                                    </div>
                                    <p className="text-sm text-gray-700 mb-2">
                                        {audit.description || audit.details}
                                    </p>
                                    <div className="flex items-center space-x-4 text-xs text-gray-500">
                                        <span>
                                            IP:{" "}
                                            {audit.ipAddress ||
                                                audit.ip_address}
                                        </span>
                                        <span>
                                            Resource:{" "}
                                            {audit.resource || "System"}
                                        </span>
                                        {audit.details && audit.description && (
                                            <span>
                                                Details: {audit.details}
                                            </span>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                    {filteredAudits.length === 0 && (
                        <div className="p-6 text-center text-gray-500">
                            {language === "zh"
                                ? "暂无审计日志"
                                : "No audit logs found"}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}
